import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import { isNonEmptyVariable, toQueryString } from "@/util/common_function";

const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : "");

// Single source of truth for the "search jackets/folders by criteria" call
// (POST bookings/jackets/search) — the exact request shape, response
// mapping, and score sort that FolderSearch's own getFolderSearchData used
// to build inline. Extracted here so the Alt+S Super Search modal calls
// the *same* function instead of a hand-rolled duplicate that could drift
// out of sync with it.
export const searchFolders = ({ requestFilter = [], pagination, cancelToken } = {}) => {
  const preparedFilter = requestFilter.map((item) =>
    item?.filterKey === "includeAliases"
      ? { ...item, value: item?.value ? "Y" : "N" }
      : item,
  );

  let url = API_ENDPOINTS.folderSearch;
  const urlParam = toQueryString({
    page: pagination?.pageIndex,
    size: pagination?.pageSize,
  });
  if (isNonEmptyVariable(urlParam)) {
    url += "?" + urlParam;
  }

  return api
    .post(url, JSON.stringify(preparedFilter), cancelToken ? { cancelToken } : undefined)
    .then((response) => {
      const { total, rows } = response?.data || {};

      const mappedRows = rows
        ?.map((jsd) => {
          const aliases = jsd?.jackets?.bio?.[0]?.bioAliases?.[0];
          return {
            folderId: jsd?.jacketId,
            numBookings: jsd?.bioSearchResponse?.numBookings,
            numCivil: jsd?.bioSearchResponse?.numCivil,
            numWarrants: jsd?.bioSearchResponse?.numWarrants,
            score: jsd?.bioSearchResponse?.score,
            aliases:
              typeof aliases != "undefined"
                ? aliases?.lName + " " + aliases?.fName + " " + aliases?.mName
                : "",
            lName: capitalize(jsd?.jackets?.bio?.[0]?.lName || ""),
            fName: capitalize(jsd?.jackets?.bio?.[0]?.fName || ""),
            mName: capitalize(jsd?.jackets?.bio?.[0]?.mName || ""),
            suffix: jsd?.jackets?.bio?.[0]?.suffix,
            race: jsd?.jackets?.bio?.[0]?.race,
            sex: jsd?.jackets?.bio?.[0]?.sex,
            dob: jsd?.jackets?.bio?.[0]?.dob,
            ssn: jsd?.jackets?.bio?.[0]?.ssn,
            street1: jsd?.jackets?.bio?.[0]?.street1,
            originalData: jsd,
            photos: jsd?.jackets?.bio?.[0]?.bioPhotos,
          };
        })
        ?.sort((a, b) => b.score - a.score);

      return { total: total || 0, rows: mappedRows || [] };
    });
};
